/* Top Shelf — scroll reveal for .ts-reveal elements.
   Progressive enhancement: if JS or IntersectionObserver is unavailable,
   a <noscript> rule in theme.liquid makes .ts-reveal fully visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function revealAll() {
    document.querySelectorAll('.ts-reveal').forEach(function (el) { el.classList.add('ts-in'); });
  }
  if (reduce || !('IntersectionObserver' in window)) {
    if (document.readyState !== 'loading') revealAll();
    else document.addEventListener('DOMContentLoaded', revealAll, { once: true });
    return;
  }
  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ts-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ts-reveal:not(.ts-in)').forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden.
    setTimeout(revealAll, 3000);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();

/* The Grange — hanging ribbon banner pinned in the header, kept OUTSIDE the
   overflow-list menu so Horizon's menu reflow can't remove it. */
(function grangeRibbon() {
  var rib;
  function grangeHref() {
    var g = document.querySelector('a[href*="the-grange"]');
    return g ? g.getAttribute('href') : '/collections/the-grange';
  }
  function place() {
    return; /* The Grange removed site-wide (Phase 1 repositioning); ribbon disabled. */
    var header = document.querySelector('header-component') || document.querySelector('.header-section') || document.querySelector('header');
    if (!header) return;
    var menu = document.querySelector('.header-menu, .menu-list');
    var links = menu ? [].slice.call(menu.querySelectorAll('a')).filter(function (a) {
      return a.offsetParent !== null && !a.classList.contains('ts-grange-ribbon');
    }) : [];
    var lastLink = links[links.length - 1];
    if (!rib) {
      rib = document.createElement('a');
      rib.className = 'ts-grange-ribbon';
      rib.href = grangeHref();
      rib.setAttribute('aria-label', 'The Grange — flagship collection');
      rib.innerHTML = '<span class="tsr-line"></span><span class="tsr-name">The<br>Grange</span><span class="tsr-sub">Flagship</span>';
      header.appendChild(rib);
      document.documentElement.classList.add('ts-grange-injected');
    }
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
    var inline = document.querySelector('.menu-list__link[href*="the-grange"]');
    if (inline) inline.style.setProperty('display', 'none', 'important');
    // Only show as a hanging tab when the inline menu is present (desktop, not drawer)
    if (!menu || menu.offsetParent === null || !lastLink) { rib.style.display = 'none'; return; }
    var hr = header.getBoundingClientRect();
    var lr = lastLink.getBoundingClientRect();
    // match the gap the ribbon sits after "Spirits" to the real gap between nav items
    var gap = 26;
    if (links.length >= 2) {
      var prev = links[links.length - 2].getBoundingClientRect();
      gap = Math.max(16, Math.round(lr.left - prev.right));
    }
    rib.style.position = 'absolute';
    rib.style.top = '0px'; /* hang from the top of the header/page downward */
    rib.style.left = Math.round(lr.right - hr.left + gap) + 'px'; /* spaced like the other nav items */
    rib.style.zIndex = '130';
    rib.style.display = '';
  }
  function init() {
    place();
    window.addEventListener('resize', place);
    setTimeout(place, 400); /* after Horizon's overflow-list settles */
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();

/* Category row — custom draggable progress scrollbar */
(function catScrollbar() {
  function wire(bar) {
    var row = (bar.previousElementSibling && bar.previousElementSibling.matches('[data-ts-cats]'))
      ? bar.previousElementSibling
      : document.querySelector('[data-ts-cats]');
    if (!row) { bar.style.display = 'none'; return; }
    var thumb = bar.querySelector('.ts-catbar__thumb');
    function sync() {
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      var w = Math.max(12, (row.clientWidth / row.scrollWidth) * 100);
      thumb.style.width = w + '%';
      thumb.style.left = (row.scrollLeft / max) * (100 - w) + '%';
    }
    function toScroll(clientX) {
      var r = bar.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      row.scrollLeft = p * (row.scrollWidth - row.clientWidth);
    }
    var dragging = false;
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    bar.addEventListener('pointerdown', function (e) { dragging = true; try { bar.setPointerCapture(e.pointerId); } catch (_) {} toScroll(e.clientX); });
    bar.addEventListener('pointermove', function (e) { if (dragging) toScroll(e.clientX); });
    bar.addEventListener('pointerup', function (e) { dragging = false; try { bar.releasePointerCapture(e.pointerId); } catch (_) {} });
    sync();
  }
  function init() { document.querySelectorAll('[data-ts-catbar]').forEach(wire); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();

/* Sticky sub-nav — keep the whisky mega-nav pinned directly beneath the header
   by publishing the live header height as --ts-header-h. */
(function navOffset() {
  function set() {
    var h = document.querySelector('header-component');
    if (h) document.documentElement.style.setProperty('--ts-header-h', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  function init() {
    set();
    window.addEventListener('resize', set, { passive: true });
    setTimeout(set, 300);
    setTimeout(set, 1200);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
